import { render, staticRenderFns } from "./editConsigneeInfo.vue?vue&type=template&id=3d3ef4e6&scoped=true&"
import script from "./editConsigneeInfo.vue?vue&type=script&lang=js&"
export * from "./editConsigneeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3ef4e6",
  null
  
)

export default component.exports